import React from 'react';
import {
    TableWrapper,
    TableTitle,
    StyledTableContainer,
    StyledTable,
    StyledTableHead,
    StyledTableBody,
    StyledTableRow,
    StyledTableHeaderCell,
    StyledTableCell,
} from './style';

const PopulationShareTable = ({ data, title, locationNames = [] }) => {
    const getTableData = () => {
        if (!data || !locationNames || locationNames.length === 0) return [];

        const ageGroups = ['60세 이상', '50~59세', '40~49세', '30~39세', '20~29세', '10~19세', '0~9세'];
        const dataKeys = ['age60plus', 'age50to59', 'age40to49', 'age30to39', 'age20to29', 'age10to19', 'age0to9'];

        return locationNames.map((location, locationIndex) => {
            const row = { location };
            ageGroups.forEach((ageGroup, ageIndex) => {
                const dataKey = dataKeys[ageIndex];
                row[ageGroup] = data[dataKey]?.[locationIndex] || 0;
            });
            return row;
        });
    };

    const tableData = getTableData();

    if (!data || !title) return null;

    return (
        <TableWrapper>
            <TableTitle>{title}</TableTitle>
            <StyledTableContainer>
                <StyledTable>
                    <StyledTableHead>
                        <StyledTableRow>
                            <StyledTableHeaderCell>지역</StyledTableHeaderCell>
                            <StyledTableHeaderCell align="right">60세 이상</StyledTableHeaderCell>
                            <StyledTableHeaderCell align="right">50~59세</StyledTableHeaderCell>
                            <StyledTableHeaderCell align="right">40~49세</StyledTableHeaderCell>
                            <StyledTableHeaderCell align="right">30~39세</StyledTableHeaderCell>
                            <StyledTableHeaderCell align="right">20~29세</StyledTableHeaderCell>
                            <StyledTableHeaderCell align="right">10~19세</StyledTableHeaderCell>
                            <StyledTableHeaderCell align="right">0~9세</StyledTableHeaderCell>
                        </StyledTableRow>
                    </StyledTableHead>
                    <StyledTableBody>
                        {tableData.map((row, index) => (
                            <StyledTableRow key={index}>
                                <StyledTableCell fontWeight="medium">{row.location}</StyledTableCell>
                                <StyledTableCell align="right">{row['60세 이상']?.toFixed(1)}%</StyledTableCell>
                                <StyledTableCell align="right">{row['50~59세']?.toFixed(1)}%</StyledTableCell>
                                <StyledTableCell align="right">{row['40~49세']?.toFixed(1)}%</StyledTableCell>
                                <StyledTableCell align="right">{row['30~39세']?.toFixed(1)}%</StyledTableCell>
                                <StyledTableCell align="right">{row['20~29세']?.toFixed(1)}%</StyledTableCell>
                                <StyledTableCell align="right">{row['10~19세']?.toFixed(1)}%</StyledTableCell>
                                <StyledTableCell align="right">{row['0~9세']?.toFixed(1)}%</StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </StyledTableBody>
                </StyledTable>
            </StyledTableContainer>
        </TableWrapper>
    );
};

export default PopulationShareTable;
